import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';
import { setRNMessageReceiver } from '../../utils/RNCommunicator/setRNMessageReceiver.util';
import { requestAppUpdate } from '../../utils/modal/requestAppUpdate.util';
import { useGetAppIsValidVersionQuery } from '../api/etc/appVersion/queries/useGetAppIsValidVersion.query';
import { usePopup } from '../popup/usePopup';

export const useCheckAppVersion = () => {
  const location = useLocation();
  const Popup = usePopup();
  const [osName, setOsName] = useState<'ios' | 'android'>();
  const [appVersion, setAppVersion] = useState<string>();

  const { data: getAppIsValidVersionQueryData } = useGetAppIsValidVersionQuery({
    searchParam: { osType: osName, version: appVersion },
  });

  async function checkAppVersionValidity(e: any) {
    try {
      const event = await JSON.parse(e.data);
      const receivedMessage = event.params;

      // 받아온 app version 을 state로 저장
      setOsName(receivedMessage.os);
      setAppVersion(receivedMessage.version);
    } catch (e) {
      // alert(`e : ${e}`);
    }
  }

  useEffect(() => {
    // 앱 환경이라면 app version 체크를 위해 deveiceInfo를 얻어옴
    if (window.ReactNativeWebView) {
      setRNMessageReceiver({ messageHandler: (e) => checkAppVersionValidity(e) });

      postMessageToRN({ messageKey: 'deviceInfo' });
    }
  }, []);

  useEffect(() => {
    if (getAppIsValidVersionQueryData?.isValid === false) {
      requestAppUpdate(Popup);
    }
  }, [getAppIsValidVersionQueryData?.isValid]);
};
